const initialState = {
  loading: false,
  churches: [],
  error: null,
  saving: false,
  selectedChurch: null,
};

const churchesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_CHURCHES_REQUEST":
      return { ...state, loading: true, error: null };

    case "FETCH_CHURCHES_SUCCESS":
      return { ...state, loading: false, churches: action.payload || [] };

    case "FETCH_CHURCHES_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "SAVE_CHURCH_SUCCESS":
      return {
        ...state,
        churches: [...(state.churches || []), ...(action.payload || [])],
      };

    case "DELETE_CHURCH_SUCCESS":
      return {
        ...state,
        churches: state.churches.filter((c) => c._id !== action.payload._id),
      };

    case "UPDATE_CHURCH_SUCCESS":
      return {
        ...state,
        churches: state.churches.map((c) =>
          c._id === action.payload._id ? action.payload : c
        ),
      };

    case "FETCH_CHURCH_BY_ID_SUCCESS":
      return { ...state, selectedChurch: action.payload };

    default:
      return state;
  }
};

export default churchesReducer;
